var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "attendance-stat-v3" },
    [
      _c("div", { staticClass: "stat-section-header" }, [
        _vm._m(0),
        _c("div", { staticClass: "header-filters" }, [
          _c(
            "div",
            { staticClass: "date-filter-group" },
            [
              _c(
                "button",
                {
                  staticClass: "date-nav-btn",
                  attrs: { type: "button", title: "Ngày trước" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSelectedDate(-1)
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-arrow-left" })]
              ),
              _c("el-date-picker", {
                staticClass: "attendance-date-picker",
                attrs: {
                  type: "date",
                  size: "small",
                  format: "dd/MM/yyyy",
                  "value-format": "yyyy-MM-dd",
                  placeholder: "Chọn ngày",
                  clearable: false,
                  "picker-options": _vm.datePickerOptions,
                },
                on: { change: _vm.handleDateChange },
                model: {
                  value: _vm.selectedDate,
                  callback: function ($$v) {
                    _vm.selectedDate = $$v
                  },
                  expression: "selectedDate",
                },
              }),
              _c(
                "button",
                {
                  staticClass: "date-current-btn",
                  attrs: { type: "button" },
                  on: { click: _vm.setToday },
                },
                [_vm._v("\n          Hôm nay\n        ")]
              ),
              _c(
                "button",
                {
                  staticClass: "date-nav-btn",
                  attrs: { type: "button", title: "Ngày sau" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSelectedDate(1)
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-arrow-right" })]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "header-badge-group" }, [
            _c("span", { staticClass: "live-indicator" }, [
              _c("span", { staticClass: "pulse-dot" }),
              _vm._v(" " + _vm._s(_vm.dayOfWeekLabel) + ", "),
              _c("strong", [_vm._v(_vm._s(_vm.formattedSelectedDate))]),
            ]),
          ]),
        ]),
      ]),
      _vm.apiError
        ? _c("el-alert", {
            staticClass: "stat-api-error",
            attrs: {
              title: _vm.apiError,
              type: "error",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      !_vm.isToday
        ? _c("el-alert", {
            staticClass: "stat-api-error",
            attrs: {
              title:
                "Số liệu lịch sử cần đối chiếu trước khi sử dụng làm báo cáo chính thức.",
              type: "warning",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "kpi-sections-wrapper" }, [
        _c("div", { staticClass: "metric-block" }, [
          _vm._m(1),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingSummary,
                  expression: "loadingSummary",
                },
              ],
              staticClass: "metric-grid",
            },
            [
              _c("div", { staticClass: "metric-card border-indigo" }, [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Tổng số học sinh"),
                ]),
                _c("div", { staticClass: "metric-val text-indigo" }, [
                  _vm._v(_vm._s(_vm.summary.totalStudents)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v("Toàn bộ trường"),
                ]),
              ]),
              _c("div", { staticClass: "metric-card border-green" }, [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Đang học"),
                ]),
                _c("div", { staticClass: "metric-val text-green" }, [
                  _vm._v(_vm._s(_vm.summary.studyingStudents)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v(_vm._s(_vm.summary.studyingRate) + "% tổng số"),
                ]),
              ]),
              _c("div", { staticClass: "metric-card border-amber" }, [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Bảo lưu"),
                ]),
                _c("div", { staticClass: "metric-val text-amber" }, [
                  _vm._v(_vm._s(_vm.summary.reservedStudents)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v("Tạm nghỉ học"),
                ]),
              ]),
              _c("div", { staticClass: "metric-card border-blue" }, [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Chờ học"),
                ]),
                _c("div", { staticClass: "metric-val text-blue" }, [
                  _vm._v(_vm._s(_vm.summary.waitingStudents)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [_vm._v("Hồ sơ mới")]),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "metric-block" }, [
          _vm._m(2),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingSummary,
                  expression: "loadingSummary",
                },
              ],
              staticClass: "metric-grid",
            },
            [
              _c("div", { staticClass: "metric-card border-emerald" }, [
                _c("span", { staticClass: "metric-label" }, [_vm._v("Đi học")]),
                _c("div", { staticClass: "metric-val text-emerald" }, [
                  _vm._v(_vm._s(_vm.summary.present)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v(_vm._s(_vm.summary.attendanceRate) + "% chuyên cần"),
                ]),
              ]),
              _c("div", { staticClass: "metric-card border-yellow" }, [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Nghỉ có phép"),
                ]),
                _c("div", { staticClass: "metric-val text-yellow" }, [
                  _vm._v(_vm._s(_vm.summary.absentPermitted)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v("Có đơn xin phép"),
                ]),
              ]),
              _c("div", { staticClass: "metric-card border-rose" }, [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Nghỉ không phép"),
                ]),
                _c("div", { staticClass: "metric-val text-rose" }, [
                  _vm._v(_vm._s(_vm.summary.absentUnpermitted)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v("Chưa rõ lý do"),
                ]),
              ]),
              _c("div", { staticClass: "metric-card border-slate" }, [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Chưa điểm danh"),
                ]),
                _c("div", { staticClass: "metric-val text-slate" }, [
                  _vm._v(_vm._s(_vm.summary.unmarked)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v("Chờ giáo viên điểm danh"),
                ]),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "metric-block" }, [
          _vm._m(3),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingSummary,
                  expression: "loadingSummary",
                },
              ],
              staticClass: "metric-grid",
            },
            [
              _c("div", { staticClass: "metric-card border-orange" }, [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Bữa sáng"),
                ]),
                _c("div", { staticClass: "metric-val text-orange" }, [
                  _vm._v(_vm._s(_vm.summary.breakfast)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v(_vm._s(_vm.summary.breakfastRate) + "% HS đi học"),
                ]),
              ]),
              _c("div", { staticClass: "metric-card border-teal" }, [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Bữa chính"),
                ]),
                _c("div", { staticClass: "metric-val text-teal" }, [
                  _vm._v(_vm._s(_vm.summary.mainMeal)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v(_vm._s(_vm.summary.mainMealRate) + "% HS đi học"),
                ]),
              ]),
              _c("div", { staticClass: "metric-card border-purple" }, [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Bữa phụ"),
                ]),
                _c("div", { staticClass: "metric-val text-purple" }, [
                  _vm._v(_vm._s(_vm.summary.snack)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v(_vm._s(_vm.summary.snackRate) + "% HS đi học"),
                ]),
              ]),
              _c("div", { staticClass: "metric-card border-dark" }, [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Bữa tối"),
                ]),
                _c("div", { staticClass: "metric-val text-dark" }, [
                  _vm._v(_vm._s(_vm.summary.dinner)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v("Học sinh đăng ký muộn"),
                ]),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "metric-block" }, [
          _vm._m(4),
          _c("div", { staticClass: "metric-grid" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingSummary,
                    expression: "loadingSummary",
                  },
                ],
                staticClass: "metric-card border-cyan",
              },
              [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Lời nhắn"),
                ]),
                _c("div", { staticClass: "metric-val text-cyan" }, [
                  _vm._v(_vm._s(_vm.summary.parentMessages)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v("Phụ huynh gửi trong ngày"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingSummary,
                    expression: "loadingSummary",
                  },
                ],
                staticClass: "metric-card border-pink",
              },
              [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Dặn thuốc"),
                ]),
                _c("div", { staticClass: "metric-val text-pink" }, [
                  _vm._v(_vm._s(_vm.summary.medicineOrders)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v("Đơn thuốc gửi cô"),
                ]),
              ]
            ),
            _c("div", { staticClass: "metric-card border-red" }, [
              _c("span", { staticClass: "metric-label" }, [
                _vm._v("Đơn chưa duyệt"),
              ]),
              _c("div", { staticClass: "metric-val text-red" }, [
                _vm._v(_vm._s(_vm.pendingAbsentRequests.pendingCount)),
              ]),
              _c("div", { staticClass: "metric-sub" }, [
                _vm._v("Đơn nghỉ chờ duyệt · Hiện tại"),
              ]),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingSummary,
                    expression: "loadingSummary",
                  },
                ],
                staticClass: "metric-card border-violet",
              },
              [
                _c("span", { staticClass: "metric-label" }, [
                  _vm._v("Đón muộn"),
                ]),
                _c("div", { staticClass: "metric-val text-violet" }, [
                  _vm._v(_vm._s(_vm.summary.latePickups)),
                ]),
                _c("div", { staticClass: "metric-sub" }, [
                  _vm._v("Học sinh đã được đón muộn"),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _c(
        "el-row",
        { staticClass: "charts-row", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 8, lg: 7 } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingSummary,
                    expression: "loadingSummary",
                  },
                ],
                staticClass: "chart-card h-100",
              },
              [
                _c("div", { staticClass: "chart-card-head" }, [
                  _c("div", [
                    _c("h3", { staticClass: "chart-title" }, [
                      _vm._v("Tỷ Lệ Đi Học"),
                    ]),
                    _c("p", { staticClass: "chart-subtitle" }, [
                      _vm._v(
                        "So với tổng số học sinh đang học (" +
                          _vm._s(_vm.summary.studyingStudents) +
                          " HS)"
                      ),
                    ]),
                  ]),
                  _c("span", { staticClass: "tag-pill tag-pill--green" }, [
                    _vm._v(
                      _vm._s(
                        _vm.isToday ? "Hôm nay" : _vm.formattedSelectedDate
                      )
                    ),
                  ]),
                ]),
                _c("div", {
                  ref: "chartAttendanceGauge",
                  staticClass: "chart-container",
                }),
                _c("div", { staticClass: "gauge-footer-stats" }, [
                  _c("div", { staticClass: "gauge-stat-box" }, [
                    _c("span", { staticClass: "g-label" }, [
                      _vm._v("Có mặt đi học"),
                    ]),
                    _c("strong", { staticClass: "g-val text-emerald" }, [
                      _vm._v(_vm._s(_vm.summary.present) + " HS"),
                    ]),
                  ]),
                  _c("div", { staticClass: "gauge-stat-box" }, [
                    _c("span", { staticClass: "g-label" }, [
                      _vm._v("Vắng mặt"),
                    ]),
                    _c("strong", { staticClass: "g-val text-rose" }, [
                      _vm._v(_vm._s(_vm.summary.absentTotal) + " HS"),
                    ]),
                  ]),
                  _c("div", { staticClass: "gauge-stat-box" }, [
                    _c("span", { staticClass: "g-label" }, [
                      _vm._v("Chưa điểm danh"),
                    ]),
                    _c("strong", { staticClass: "g-val text-slate" }, [
                      _vm._v(_vm._s(_vm.summary.unmarked) + " HS"),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 16, lg: 10 } }, [
            _c("div", { staticClass: "chart-card h-100" }, [
              _c("div", { staticClass: "chart-card-head" }, [
                _c("div", [
                  _c("h3", { staticClass: "chart-title" }, [
                    _vm._v("Xu Hướng Chuyên Cần & Tổng Học Sinh"),
                  ]),
                  _c("p", { staticClass: "chart-subtitle" }, [
                    _vm._v(
                      "Thể hiện số lượng đi học và tỷ lệ % so với tổng số học sinh"
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "scope-toggle-tabs" },
                  _vm._l(_vm.scopeOptions, function (scope) {
                    return _c(
                      "button",
                      {
                        key: scope.value,
                        class: [
                          "scope-btn",
                          { active: _vm.currentTrendScope === scope.value },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.changeTrendScope(scope.value)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(scope.label) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _c("div", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingTrend,
                    expression: "loadingTrend",
                  },
                ],
                ref: "chartAttendanceTrend",
                staticClass: "chart-container",
              }),
              _c("div", { staticClass: "trend-legend-bar" }, [
                _c("div", { staticClass: "legend-item" }, [
                  _c("span", { staticClass: "legend-color-box bar-color" }),
                  _c("span", [_vm._v("Số học sinh đi học")]),
                ]),
                _c("div", { staticClass: "legend-item" }, [
                  _c("span", {
                    staticClass: "legend-color-box bg-slate-color",
                  }),
                  _c("span", [_vm._v("Tổng số học sinh")]),
                ]),
                _c("div", { staticClass: "legend-item" }, [
                  _c("span", { staticClass: "legend-color-box line-color" }),
                  _c("span", [_vm._v("Tỷ lệ đi học (%)")]),
                ]),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 24, lg: 7 } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingSummary,
                    expression: "loadingSummary",
                  },
                ],
                staticClass: "chart-card h-100",
              },
              [
                _c("div", { staticClass: "chart-card-head" }, [
                  _c("div", [
                    _c("h3", { staticClass: "chart-title" }, [
                      _vm._v("Điểm Danh Theo Suất Ăn"),
                    ]),
                    _c("p", { staticClass: "chart-subtitle" }, [
                      _vm._v("Thống kê 4 bữa: Sáng, Chính, Phụ, Tối"),
                    ]),
                  ]),
                  _c("span", { staticClass: "tag-pill tag-pill--orange" }, [
                    _vm._v("4 bữa ăn"),
                  ]),
                ]),
                _c("div", {
                  ref: "chartMealStats",
                  staticClass: "chart-container chart-container--meal",
                }),
                _c("div", { staticClass: "meal-detail-list" }, [
                  _c("div", { staticClass: "meal-detail-item" }, [
                    _c("div", { staticClass: "meal-name" }, [
                      _c("i", { staticClass: "el-icon-sunrise text-orange" }),
                      _vm._v(" Bữa Sáng:"),
                    ]),
                    _c("div", { staticClass: "meal-counts" }, [
                      _c("b", [_vm._v(_vm._s(_vm.summary.breakfast))]),
                      _vm._v(
                        " / " +
                          _vm._s(_vm.summary.present) +
                          " HS\n              "
                      ),
                      _c("span", { staticClass: "meal-rate text-orange" }, [
                        _vm._v("(" + _vm._s(_vm.summary.breakfastRate) + "%)"),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "meal-detail-item" }, [
                    _c("div", { staticClass: "meal-name" }, [
                      _c("i", { staticClass: "el-icon-food text-teal" }),
                      _vm._v(" Bữa Chính (Trưa):"),
                    ]),
                    _c("div", { staticClass: "meal-counts" }, [
                      _c("b", [_vm._v(_vm._s(_vm.summary.mainMeal))]),
                      _vm._v(
                        " / " +
                          _vm._s(_vm.summary.present) +
                          " HS\n              "
                      ),
                      _c("span", { staticClass: "meal-rate text-teal" }, [
                        _vm._v("(" + _vm._s(_vm.summary.mainMealRate) + "%)"),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "meal-detail-item" }, [
                    _c("div", { staticClass: "meal-name" }, [
                      _c("i", {
                        staticClass: "el-icon-coffee-cup text-purple",
                      }),
                      _vm._v(" Bữa Phụ (Xế):"),
                    ]),
                    _c("div", { staticClass: "meal-counts" }, [
                      _c("b", [_vm._v(_vm._s(_vm.summary.snack))]),
                      _vm._v(
                        " / " +
                          _vm._s(_vm.summary.present) +
                          " HS\n              "
                      ),
                      _c("span", { staticClass: "meal-rate text-purple" }, [
                        _vm._v("(" + _vm._s(_vm.summary.snackRate) + "%)"),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "meal-detail-item" }, [
                    _c("div", { staticClass: "meal-name" }, [
                      _c("i", { staticClass: "el-icon-moon text-dark" }),
                      _vm._v(" Bữa Tối:"),
                    ]),
                    _c("div", { staticClass: "meal-counts" }, [
                      _c("b", [_vm._v(_vm._s(_vm.summary.dinner))]),
                      _vm._v(
                        " / " +
                          _vm._s(_vm.summary.present) +
                          " HS\n              "
                      ),
                      _c("span", { staticClass: "meal-rate text-dark" }, [
                        _vm._v("(" + _vm._s(_vm.summary.dinnerRate) + "%)"),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "class-attendance-section" },
        [
          _c(
            "div",
            {
              class: [
                "class-attendance-head",
                { "is-expanded": _vm.showClassTable },
              ],
            },
            [
              _vm._m(5),
              _c(
                "div",
                { staticClass: "class-attendance-actions" },
                [
                  _c("span", { staticClass: "class-counter-badge" }, [
                    _c("i", { staticClass: "el-icon-school" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.filteredClassAttendanceList.length) +
                        " Lớp\n        "
                    ),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticClass: "table-toggle-btn",
                      attrs: { size: "small", type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          _vm.showClassTable = !_vm.showClassTable
                        },
                      },
                    },
                    [
                      _c("i", {
                        class: _vm.showClassTable
                          ? "el-icon-arrow-up"
                          : "el-icon-arrow-down",
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.showClassTable
                              ? "Thu gọn bảng"
                              : "Xem chi tiết bảng"
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("el-collapse-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showClassTable,
                    expression: "showClassTable",
                  },
                ],
                staticClass: "class-table-collapsible-body",
              },
              [
                _c("div", { staticClass: "class-attendance-filter-bar" }, [
                  _c(
                    "div",
                    { staticClass: "filter-chip" },
                    [
                      _c("span", { staticClass: "chip-label" }, [
                        _c("i", { staticClass: "el-icon-collection-tag" }),
                        _vm._v(" Khối:"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticClass: "grade-select",
                          attrs: {
                            size: "small",
                            placeholder: "Tất cả các khối",
                          },
                          model: {
                            value: _vm.selectedTableGrade,
                            callback: function ($$v) {
                              _vm.selectedTableGrade = $$v
                            },
                            expression: "selectedTableGrade",
                          },
                        },
                        _vm._l(_vm.gradeOptions, function (g) {
                          return _c("el-option", {
                            key: g.value,
                            attrs: { label: g.label, value: g.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "search-box" },
                    [
                      _c("el-input", {
                        staticClass: "class-search-input",
                        attrs: {
                          size: "small",
                          placeholder: "Tìm theo tên lớp...",
                          "prefix-icon": "el-icon-search",
                          clearable: "",
                        },
                        model: {
                          value: _vm.tableSearchQuery,
                          callback: function ($$v) {
                            _vm.tableSearchQuery = $$v
                          },
                          expression: "tableSearchQuery",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm.classesError
                  ? _c("el-alert", {
                      staticClass: "stat-api-error",
                      attrs: {
                        title: _vm.classesError,
                        type: "error",
                        closable: false,
                        "show-icon": "",
                      },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingClasses,
                        expression: "loadingClasses",
                      },
                    ],
                    staticClass: "class-attendance-table-wrap",
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticClass: "modern-class-attendance-table",
                        attrs: {
                          data: _vm.filteredClassAttendanceList,
                          stripe: "",
                          border: "",
                          size: "small",
                          "max-height": "500",
                          "empty-text": "Chưa có dữ liệu điểm danh theo lớp",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "index",
                            label: "STT",
                            width: "55",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Lớp Học & Khối",
                            "min-width": "170",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "class-meta-cell" },
                                    [
                                      _c(
                                        "strong",
                                        { staticClass: "class-name-txt" },
                                        [_vm._v(_vm._s(scope.row.className))]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "grade-pill",
                                          class: "pill-" + scope.row.gradeId,
                                        },
                                        [_vm._v(_vm._s(scope.row.gradeName))]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Sĩ Số",
                            width: "90",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "badge-total-students" },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.kidsTotalNumber) +
                                          " HS"
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Tiến Độ Điểm Danh",
                            width: "155",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "attendance-progress-cell" },
                                    [
                                      scope.row.attendanceNo === 0
                                        ? _c(
                                            "span",
                                            { staticClass: "badge-done" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-circle-check",
                                              }),
                                              _vm._v(
                                                " Đã điểm danh (" +
                                                  _vm._s(
                                                    scope.row.attendanceYes
                                                  ) +
                                                  ")\n              "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "badge-pending" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-warning-outline",
                                              }),
                                              _vm._v(
                                                " Còn " +
                                                  _vm._s(
                                                    scope.row.attendanceNo
                                                  ) +
                                                  " HS\n              "
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Đi Học (Chuyên Cần)",
                            "min-width": "175",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "rate-progress-cell" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "rate-info-row" },
                                        [
                                          _c(
                                            "strong",
                                            { staticClass: "text-emerald" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.goSchoolNumber
                                                ) + " HS"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "rate-pct-tag",
                                              class: _vm.getRateColorClass(
                                                scope.row
                                              ),
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    scope.row.attendanceRate
                                                  ) +
                                                  "%\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "progress-bar-bg" },
                                        [
                                          _c("div", {
                                            staticClass: "progress-bar-fill",
                                            style: {
                                              width:
                                                scope.row.attendanceRate + "%",
                                              backgroundColor: _vm.getRateColor(
                                                scope.row
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Nghỉ Học",
                            width: "150",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "absent-stat-cell" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "stat-permit",
                                          attrs: { title: "Nghỉ có phép" },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-document-checked",
                                          }),
                                          _vm._v(" Có phép: "),
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(scope.row.absentWithPermit)
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "stat-no-permit",
                                          attrs: { title: "Nghỉ không phép" },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-circle-close",
                                          }),
                                          _vm._v(" K.phép: "),
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(scope.row.absentNoPermit)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Báo Ăn (Bữa)",
                            width: "185",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "meal-mini-chips" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "chip-m chip-breakfast",
                                          attrs: { title: "Bữa sáng" },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-sunrise",
                                          }),
                                          _vm._v(
                                            " S: " +
                                              _vm._s(scope.row.mealBreakfast) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "chip-m chip-lunch",
                                          attrs: { title: "Bữa trưa" },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-food",
                                          }),
                                          _vm._v(
                                            " T: " +
                                              _vm._s(scope.row.mealLunch) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "chip-m chip-snack",
                                          attrs: { title: "Bữa xế" },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-coffee-cup",
                                          }),
                                          _vm._v(
                                            " X: " +
                                              _vm._s(scope.row.mealSnack) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "chip-m chip-dinner",
                                          attrs: { title: "Bữa tối" },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-moon",
                                          }),
                                          _vm._v(
                                            " Tối: " +
                                              _vm._s(scope.row.mealDinner) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Đón Về",
                            width: "130",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "leave-stat-cell" },
                                    [
                                      _c("span", { staticClass: "leave-yes" }, [
                                        _c("i", {
                                          staticClass: "el-icon-check",
                                        }),
                                        _vm._v(
                                          " Đã về: " +
                                            _vm._s(scope.row.leaveYes)
                                        ),
                                      ]),
                                      _c("span", { staticClass: "leave-no" }, [
                                        _c("i", {
                                          staticClass: "el-icon-time",
                                        }),
                                        _vm._v(
                                          " Chưa về: " +
                                            _vm._s(scope.row.leaveNo)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-title-group" }, [
      _c("div", { staticClass: "header-icon-badge" }, [
        _c("i", { staticClass: "el-icon-user-solid" }),
      ]),
      _c("div", [
        _c("h2", { staticClass: "header-title" }, [
          _vm._v("Thống kê điểm danh & Chuyên cần học sinh"),
        ]),
        _c("p", { staticClass: "header-subtitle" }, [
          _vm._v(
            "Tổng hợp trạng thái học sinh, điểm danh đi học và các suất ăn trong ngày"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "metric-block-title" }, [
      _c("i", { staticClass: "el-icon-s-custom text-indigo" }),
      _c("span", [_vm._v("Hồ Sơ Học Sinh")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "metric-block-title" }, [
      _c("i", { staticClass: "el-icon-date text-emerald" }),
      _c("span", [_vm._v("Điểm Danh Đi Học")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "metric-block-title" }, [
      _c("i", { staticClass: "el-icon-dish text-orange" }),
      _c("span", [_vm._v("Điểm Danh Suất Ăn")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "metric-block-title" }, [
      _c("i", { staticClass: "el-icon-chat-line-square text-cyan" }),
      _c("span", [_vm._v("Tương Tác & Đón Trả")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "class-attendance-title-group" }, [
      _c("div", { staticClass: "section-icon-badge" }, [
        _c("i", { staticClass: "el-icon-s-grid" }),
      ]),
      _c("div", [
        _c("h3", { staticClass: "section-heading" }, [
          _vm._v("Chỉ Số Điểm Danh Từng Lớp Học"),
        ]),
        _c("p", { staticClass: "section-subheading" }, [
          _vm._v(
            "\n            Theo dõi chi tiết sĩ số, tiến độ điểm danh đến, chuyên cần đi học, nghỉ học và các suất ăn theo lớp\n          "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }